import * as React from 'react';
import styled from 'styled-components';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@material-ui/core/Typography';

const StyledTypography = styled(MuiTypography)``;

export type DSTypographyProps<C extends React.ElementType> = MuiTypographyProps<C, { component?: C }>;

export function DSTypography<C extends React.ElementType>(props: DSTypographyProps<C>): JSX.Element {
    return <StyledTypography {...props} />;
}
DSTypography.displayName = 'DSTypography';
